<button
  [type]="type()"
  [attr.data-testid]="testId()"
  (click)="buttonClick($event)"
  [disabled]="isDisabled()"
  [class]="class()"
  [ngClass]="{
    'bg-transparent !border border-solid': outlined(),
    '!w-10 !p-0': circle(),
  }"
  class="w-fit text-sm h-10 border-0 outline-0 rounded-full flex items-center justify-center py-0 px-5 uppercase cursor-pointer transition-colors">
  @if (isLoading()) {
    <svg
      class="animate-spin -ml-1 mr-3 h-5 w-5"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24">
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  }
  <span class="button-content">
    <ng-content></ng-content>
  </span>
  @if (icon() && !isLoading()) {
    <span
      class="material-symbols-outlined text-xs ml-3 w-4"
      [class.max-md:hidden]="!showIconOnMobile()">
      {{ icon() }}
    </span>
  }
</button>
